<template>
  <div>
    <load-profile />
    <!-- Table Container Card -->
    <b-card>
      <b-row>
        <b-col
          cols="12"
          class="text-right"
        >
          <b-button
            v-if="$can('update', 'assistantvip')"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="primary"
            class="mb-1"
            :to="{ name: 'update-assistant-vip', params: { id: $route.params.id } }"
          >
            <feather-icon icon="EditIcon" />
            {{ $t("button.update") }}
          </b-button>
          <b-button
            v-if="$can('create', 'assistantvip')"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="primary"
            class="mb-1 ml-1"
            :to="{ name: 'create-assistant-vip', query: { id: $route.params.id } }"
          >
            <feather-icon icon="CopyIcon" />
            {{ $t("button.clone") }}
          </b-button>
        </b-col>
      </b-row>
      <n-input-view
        v-model="data"
        :fields="fields"
        :init-value="initData"
      />
      <b-row>
        <b-col
          cols="12"
          class="text-right"
        >
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            class="mt-1"
            @click="back"
          >
            {{ $t("button.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import Ripple from 'vue-ripple-directive'
import NInputView from '@/components/NInputView.vue'
import FormInput from './formInput'

const AssistantRepository = Repository.get('assistantVip')

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    NInputView,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        lastName: null,
        phone: null,
        username: null,
        password: null,
        minBetTime: 0,
        maxBetTime: 0,
        maxBetGame: 0,
        maxDrawBetGame: 0,
        maxWinDay: 0,
        maxBetAmountParley: 0,
        ccy: null,
        isEnable: true,
        isReadonly: false,
      },
      initData: {},
      loading: false,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.name
        ? this.$store.state.profile
        : JSON.parse(localStorage.getItem('userData'))
    },
    userId() {
      if (this.$store.state.profile.id) {
        return this.$store.state.profile.id
      }

      return this.userData?.id
    },
  },
  mounted() {
    this.show()
  },
  methods: {
    show() {
      AssistantRepository.show(this.$route.params.id).then(response => {
        if (response?.data?.data) {
          this.initData = {
            ...response.data.data,
          }
        }
      })
    },
    deleteItem() {
      AssistantRepository.delete(this.$route.params.id)
        .then(() => {
          this.back()
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    back() {
      this.$router.back()
    },
  },
  setup() {
    const fields = [...FormInput]

    return { fields }
  },
}
</script>
